export const formatPhoneNumber = (phone: string = ''): string | null => {
  const tempPhone = phone.replace(/[^\d]/g, '');
  if (tempPhone.length === 11 && tempPhone[0] === '7')
    return tempPhone.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1($2) $3-$4-$5');

  return null;
};